import { delay } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { STpNameUpdateRequest } from '../../DTO/stp-name-update-request.model';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';

@Component({
  selector: 'app-stp-main-update',
  templateUrl: './stp-main-update.component.html',
  styleUrls: ['./stp-main-update.component.css'],
})
export class StpMainUpdateComponent implements OnInit {
  constructor(
    // private tab: StpTabComponent,
    private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private notification: NzNotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.stpApplicationId = this.route.snapshot.params.id;
  }
  basicProfileForm!: FormGroup;
  isEditMode!: boolean;
  stpName = '';
  stpApplicationId: number;
  stp: STpNameUpdateRequest = new STpNameUpdateRequest();
  stpNameAlredyExist = false;

  timeout: any = null;
  stpNameRegex = /^[a-zA-Z\s][a-zA-Z0-9\s][\w\s.,-,(,)]+$/;
  // tslint:disable-next-line: typedef
  ngOnInit() {
    this.basicProfileForm = this.fb.group({
      // stpName: [
      //   '',
      //   [Validators.required, Validators.pattern(this.stpNameRegex)],
      // ],
      stpName: ['', [Validators.required]],
      stpNameBangla: ['', Validators.required],
    });
    this.getStpApplicationById();
    this.stpApplicationId = this.route.snapshot.params.id;
  }

  private getStpApplicationById() {
    this.stpRegistrationStorageService
      .readBasicProfileById(this.stpApplicationId)
      .subscribe((res) => {
        this.basicProfileForm.patchValue({
          stpName: res.data.stpName,
          stpNameBangla: res.data.stpNameBangla,
        });
      });
  }

  update() {
    this.stp.stpMainId = this.stpApplicationId;
    this.stp.stpName = this.basicProfileForm.value.stpName;
    this.stp.stpNameBangla = this.basicProfileForm.value.stpNameBangla;

    this.stpRegistrationStorageService.updateStpMain(this.stp).subscribe({
      next: (res) => {
        this.notification.success('Success', 'STP name Updated Successfully!');
        this.router.navigate(['/home//stp-registration/stp-applications']);
      },
      error: (error) => this.notification.error('Failed', error.message),
    });
  }

  async checkStpNameExist(stpName: any) {
    this.stpNameAlredyExist = false;
    if (stpName.value.length > 3) {
      this.stpRegistrationStorageService
        .checkStpNameExist(stpName.value)
        .pipe(delay(1000))
        .subscribe({
          next: (res) => {
            if (res.data == null) {
              this.stpNameAlredyExist = false;
            } else {
              this.stpNameAlredyExist = true;
              this.basicProfileForm.controls.stpName.setErrors({
                incorrect: true,
              });
            }
          },
        });
    }
  }
}
